import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mediastation",
  "use": "icon-mediastation-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-mediastation\"><title></title><polygon points=\"619.38 479.46 619.65 479.74 619.93 479.46 619.38 479.46\" /><path d=\"M921,50.62H103.4A103.21,103.21,0,0,0,.19,153.83V706.37A103.21,103.21,0,0,0,103.4,809.58H462V913.75H211.75V974H812V913.75H562V809.58H921a103.21,103.21,0,0,0,103.21-103.21V153.83A103.21,103.21,0,0,0,921,50.62ZM667.74,527.82,619.66,575.9,454.9,411.15V652h-82V409.47L206.59,575.79,158.5,527.7,413.06,273.14l.12.12,48,48L578.47,438.55V196.46h82V438.92L826.13,273.26l48.08,48.08L667.74,527.82Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/mediastation.svg
// module id = uWCQ
// module chunks = 54